export default {
  data() {
    return {
      quality: {},
      typeHash: {
        1: {
          name: "进攻型",
        },
        2: {
          name: "防御型",
        },
        3: {
          name: "速度型",
        },
      },
      petHash: {
        1: {
          name: "双头龙",
          step: [
            require("@img/pets/blue_1.png"),
            require("@img/pets/blue_2.png"),
            require("@img/pets/blue_3.png"),
          ],
          fitSize: [
            require("@img/pets/fitsize/blue_1.png"),
            require("@img/pets/fitsize/blue_2.png"),
            require("@img/pets/fitsize/blue_3.png"),
          ],
          dialog: [],
        },
        2: {
          name: "肥龙",
          step: [
            require("@img/pets/green_1.png"),
            require("@img/pets/green_2.png"),
            require("@img/pets/green_3.png"),
          ],
          fitSize: [
            require("@img/pets/fitsize/green_1.png"),
            require("@img/pets/fitsize/green_2.png"),
            require("@img/pets/fitsize/green_3.png"),
          ],
          dialog: [],
        },
        3: {
          name: "大嘴鸟",
          step: [
            require("@img/pets/red_1.png"),
            require("@img/pets/red_2.png"),
            require("@img/pets/red_3.png"),
          ],
          fitSize: [
            require("@img/pets/fitsize/red_1.png"),
            require("@img/pets/fitsize/red_2.png"),
            require("@img/pets/fitsize/red_3.png"),
          ],
          dialog: [],
        },
        4: {
          name: "红毛雪怪",
          step: [
            require("@img/pets/snow_4_1.png"),
            require("@img/pets/snow_4_2.png"),
            require("@img/pets/snow_4_3.png"),
          ],
          fitSize: [
            require("@img/pets/fitsize/snow_4_1.png"),
            require("@img/pets/fitsize/snow_4_2.png"),
            require("@img/pets/fitsize/snow_4_3.png"),
          ],
          dialog: [
            {
              talker: 1,
              content: "红毛雪怪：嘿我亲爱的弟弟",
              pic: require("@img/pets/fitsize/snow_4_1.png"),
            },
            {
              talker: 2,
              content: "肥龙：大哥你怎么来了",
              pic: require("@img/pets/fitsize/green_1.png"),
            },
            {
              talker: 1,
              content:
                "红毛雪怪：我出来旅游，顺便看看你，我带了冰镇猪肉，要一起试试吗。",
              pic: require("@img/pets/fitsize/snow_4_1.png"),
            },
            {
              talker: 2,
              content: "肥龙：那当然！",
              pic: require("@img/pets/fitsize/green_1.png"),
            },
          ],
        },
        5: {
          name: "剑齿虎",
          step: [
            require("@img/pets/tiger_5_1.png"),
            require("@img/pets/tiger_5_2.png"),
            require("@img/pets/tiger_5_3.png"),
          ],
          fitSize: [
            require("@img/pets/fitsize/tiger_5_1.png"),
            require("@img/pets/fitsize/tiger_5_2.png"),
            require("@img/pets/fitsize/tiger_5_3.png"),
          ],
          dialog: [
            {
              talker: 1,
              content: "剑齿虎：嘿老伙计，好久不见",
              pic: require("@img/pets/fitsize/tiger_5_1.png"),
            },
            {
              talker: 2,
              content: "泰坦鸟：嘿伙计你怎么来了",
              pic: require("@img/pets/fitsize/red_1.png"),
            },
            {
              talker: 1,
              content: "剑齿虎：没啥重要的事，主要是想我的好朋友了，来看看你。",
              pic: require("@img/pets/fitsize/tiger_5_1.png"),
            },
            {
              talker: 1,
              content:
                "剑齿虎：我来这儿有点累，如果能有人请我去一趟游乐园就更好了。",
              pic: require("@img/pets/fitsize/tiger_5_1.png"),
            },
            {
              talker: 2,
              content: "泰坦鸟（汗颜）：行吧",
              pic: require("@img/pets/fitsize/red_1.png"),
            },
          ],
        },
        6: {
          name: "巨猿",
          step: [
            require("@img/pets/gorilla_6_1.png"),
            require("@img/pets/gorilla_6_2.png"),
            require("@img/pets/gorilla_6_3.png"),
          ],
          fitSize: [
            require("@img/pets/fitsize/gorilla_6_1.png"),
            require("@img/pets/fitsize/gorilla_6_2.png"),
            require("@img/pets/fitsize/gorilla_6_3.png"),
          ],
          dialog: [
            {
              talker: 2,
              content: "双头龙（左）：今天肥龙给了我一根香蕉",
              pic: require("@img/pets/fitsize/blue_1.png"),
            },
            {
              talker: 1,
              content: "双头龙（右）：胡说！明明是给我的",
              pic: require("@img/pets/fitsize/blue_1.png"),
            },
            {
              talker: 2,
              content: "双头龙（左）：给我的！",
              pic: require("@img/pets/fitsize/blue_1.png"),
            },
            {
              talker: 1,
              content: "路过的巨猿：别吵啦，我们做个对咱们都有好处的交易如何。",
              pic: require("@img/pets/fitsize/gorilla_6_1.png"),
            },
            {
              talker: 2,
              content: "双头龙：什么交易",
              pic: require("@img/pets/fitsize/blue_1.png"),
            },
            {
              talker: 1,
              content:
                "巨猿：你把香蕉给我，我过2年还给你们两根香蕉，这样你们就不用吵架了",
              pic: require("@img/pets/fitsize/gorilla_6_1.png"),
            },
            {
              talker: 2,
              content: "双头龙（左）：听起来不错",
              pic: require("@img/pets/fitsize/blue_1.png"),
            },
            {
              talker: 1,
              content: "双头龙（右）：我觉得行",
              pic: require("@img/pets/fitsize/blue_1.png"),
            },
            {
              talker: 0,
              content: "巨猿带着香蕉走了",
              pic: "",
            },
            {
              talker: 2,
              content: "双头龙（一起）：总觉得哪里不对",
              pic: require("@img/pets/fitsize/blue_1.png"),
            },
          ],
        },
      },
    };
  },
};
